
const Ordinacija = function(DS) {
    return DS.defineResource({
        name: 'Ordinacija',
        endpoint: '/ordinacije'
    });
};

Ordinacija.$inject = ['DS'];


export {Ordinacija};



// WEBPACK FOOTER //
// ./app/models/ordinacija.js